import { axios } from '@vyce/core/src/api';

import { CreateUserRequest, GetUserData, GetUsersData, UpdateUserArgs, ChangePasswordData } from '../types';
import { Address, RolesDTO, User } from '../../types';
import config from '../config';

const URL = `${config.gatewayApiUrl}`;

export const checkIfAvailableRequest = (data: { ni_number?: string; phone?: string; email?: string }) => {
  return axios.post(`${URL}/admin/v1/users/user_is_taken`, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

// The IAM source of truth for a user's positions (role, owner, permissions,
// resources) now that /core no longer returns them.
export const getUserBasicDataRequest = ({ userId }: GetUserData) => {
  return axios.post<User>(`${URL}/admin/v1/users/${userId}/basic`, { add_core_data: true });
};

export const getEmployeeDataRequest = ({ userId }: GetUserData) => {
  return axios.post(`${URL}/admin/v1/users/${userId}/employee`, { add_core_data: true });
};

export const restoreUserRequest = (userId: string) => {
  return axios.post(`${URL}/admin/v1/users/${userId}/restore_user`);
};

export const createUserRequest = (data: CreateUserRequest) => {
  return axios.post(`${URL}/admin/v1/users`, data);
};

export const saveCSCSRefNumberRequest = (cscsNumber: string, userId: string) => {
  return axios.put(`${URL}/admin/v1/users/${userId}/save_cscs_ref_number`, { serial_number: cscsNumber });
};

export const updateUserRequest = ({ userId, data }: UpdateUserArgs) => {
  return axios.put(`${URL}/admin/v1/users/${userId}`, data);
};

export const changeUserAddressRequest = (address: Address, userId: string) => {
  return axios.put(`${URL}/admin/v1/users/${userId}/address`, { ...address });
};

export const changeEmailByAdminRequest = (data: {
  recaptcha_token: string;
  user_id: string;
  email: string;
}) => {
  return axios.post(`${URL}/admin/v1/users/${data.user_id}/change_email`, data);
};

export const changePhoneByAdminRequest = (data: {
  recaptcha_token: string;
  user_id: string;
  phone: string;
}) => {
  return axios.post(`${URL}/admin/v1/users/${data.user_id}/change_phone`, data);
};

export const changeUserAvatarByAdminRequest = ({
  data,
  userId,
}: {
  data: {
    photo_url: string;
    avatar_url: string;
    file_name: string;
  };
  userId: string;
}) => {
  return axios.post(`${URL}/admin/v1/users/${userId}/change_photo`, data);
};

export const changePasswordByLegendRequest = (data: ChangePasswordData, userId?: string) => {
  return axios.post(`${URL}/admin/v1/users/${userId}/change_password`, data);
};

export const getPassportRequest = ({ userId }: GetUserData) => {
  return axios.get(`${URL}/admin/v1/users/${userId}/passports`);
};

export const deleteUserRequest = (userId: string) => {
  return axios.delete(`${URL}/admin/v1/users/${userId}`);
};

export const deleteUserPermanentlyRequest = (userId: string, name: string) => {
  return axios.delete(`${URL}/admin/v1/users/${userId}/permanent`, { data: { name } });
};

// /core no longer carries user.positions — the Roles & Permissions screen pairs
// this with getUserBasicDataRequest and only takes qualifications/surveys from here.
export const getUserDataRequest = ({ userId, addCoreData }: GetUserData & { addCoreData?: boolean }) => {
  return axios.get(`${URL}/admin/v1/users/${userId}/core`, {
    params: addCoreData === undefined ? undefined : { add_core_data: addCoreData },
  });
};

export const fetchUsersRequest = (data: GetUsersData & { roles?: boolean }) => {
  return axios.post<{ items: User[]; count: number }>(`${URL}/admin/v1/users/search`, data);
};

// TO REPLACE WITH THE NEW API

export const fetchUserRolesRequest = ({ userId }: { userId: string }) => {
  return axios.get<RolesDTO>(`/admin/users/${userId}/roles`);
};

export const getUserAvailableTasksRequest = (token: string, userId?: string) => {
  return axios.get(`/admin/users/tasks/qualifications/${userId}`);
};

export const getUserQualificationsRequest = (token: string, userId?: string) => {
  return axios.get(`/admin/users/qualifications/${userId}`);
};
